import { render } from "./TeamList.vue?vue&type=template&id=38209c6d"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__